const TestsActionType = {
    FETCH_ALL_TESTS: "FETCH_ALL_TESTS",
    FETCH_SINGLE_TEST: "FETCH_SINGLE_TEST",
    ADD_TEST: "ADD_TEST",
    EDIT_TEST: "EDIT_TEST",
    DELETE_TEST: "DELETE_TEST",
    COMPLETE_TEST: "COMPLETE_TEST"
}
export default TestsActionType;